<div class="ion-padding">
  <div class="position-relative" *ngIf="showTts && data.disable_touch_to_speak == '0' && ttsText; else noTts">
    <app-messagebubble [text]="ttsText"></app-messagebubble>
    <h2 [ngStyle]="{'color': b.subtitle_color }" class="dashboard-button" expand="full" [innerHTML]="b.title"></h2>
  </div>
  
  <ng-template #noTts>
    <h2 [ngStyle]="{'color': b.subtitle_color }" class="title-button" expand="full" [innerHTML]="b.title"></h2>
  </ng-template>
</div>